import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "..";

interface ClientProfileState {
  questionnaireResponse: QuestionnaireResponse | undefined;
}

const initialState: ClientProfileState = { questionnaireResponse: undefined };

const reducers = {
  updateQuestionnaireResponse: (
    state: ClientProfileState,
    action: PayloadAction<QuestionnaireResponse | undefined>,
  ) => {
    state.questionnaireResponse = action.payload;
  },
};

const clientProfileSlice = createSlice({
  name: "clientProfile",
  initialState,
  reducers,
});

export const { updateQuestionnaireResponse } = clientProfileSlice.actions;

export const selectQuestionnaireResponse = (state: RootState) =>
  state.clientProfile.questionnaireResponse;

export default clientProfileSlice.reducer;
